// @flow
import * as React from 'react';

import { AvatarImages } from 'constants/AvatarConstants.js';
import Avatar from 'components/Avatar.jsx';

import type { AvatarSize } from 'components/Avatar.jsx';

type Props = {
  size?: AvatarSize,
  className?: ?string,
};

export default class OrgAvatar extends React.PureComponent<Props> {
  render() {
    const { size, className } = this.props;

    return <Avatar size={size} className={className} image={AvatarImages.ORG_AVATAR} />;
  }
}
